// extracted by mini-css-extract-plugin
export default {"close":"CloseBtn_close__W82M9","closeIcon":"CloseBtn_closeIcon__fBuWg"};